import {
  FormControlLabel,
  Checkbox,
  Typography,
  Dialog,
} from "@material-ui/core";
import { MobilePopoverCard } from "halifax";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { RouteComponentProps } from "react-router-dom";
import { SMOKE_TEST_MODAL, TAPPED_SMOKETEST_CTA } from "redmond";
import { FeatureSmokeTestModalContent } from "./FeatureSmokeTestModalContent";
import "./styles.scss";
import { FeatureSmokeTestConnectorProps } from "./container";
import {
  ADD_CARS,
  PackagesSmokeTestPropVariantType,
  PARTIAL_STAYS,
} from "../../../../context/experiments";
import { trackEvent } from "../../../../api/v0/trackEvent";

interface IFeatureSmokeTestProps
  extends FeatureSmokeTestConnectorProps,
    RouteComponentProps {
  isMobile?: boolean;
  variant: PackagesSmokeTestPropVariantType;
}
export const FeatureSmokeTest = ({
  isMobile = false,
  variant,
  updateHasSeenPackageSmokeTest,
  entryProperties,
}: IFeatureSmokeTestProps) => {
  const [openModal, setOpenModal] = useState(false);

  const onClose = () => {
    setOpenModal(false);
    updateHasSeenPackageSmokeTest(true);
  };

  useEffect(() => {
    if (openModal) {
      trackEvent({
        eventName: SMOKE_TEST_MODAL,
        properties: {
          test_name:
            variant === PARTIAL_STAYS
              ? "package_partial_stay"
              : variant === ADD_CARS
              ? "package_add_car"
              : variant,
        },
      });
    }
  }, [openModal]);

  const renderPopover = React.useCallback(() => {
    if (isMobile) {
      return (
        <MobilePopoverCard
          id="feature-smoke-test-modal-pop-up"
          open={openModal}
          className="mobile-feature-smoke-test-modal-popup"
          contentClassName="mobile-feature-smoke-test-modal-content-wrapper"
          onClose={onClose}
        >
          <FeatureSmokeTestModalContent
            onClose={onClose}
            variant={variant}
            isMobile={isMobile}
            entryProperties={entryProperties.properties}
          />
        </MobilePopoverCard>
      );
    }
    return (
      <Dialog
        role="tooltip"
        id="feature-smoke-test-modal-popup"
        open={openModal}
        className="feature-smoke-test-modal-popup"
        onClose={onClose}
        /** TransitionProps fixes `role` issue bug in MUIv4 - https://github.com/mui/material-ui/issues/18935  */
        TransitionProps={{ role: "none" } as never}
        PaperProps={{
          /* eslint-disable */
          // @ts-ignore: Fix the type definition of PaperProps to include tabIndex.
          tabIndex: 0,
          /* eslint-enable */
        }}
      >
        <FeatureSmokeTestModalContent
          onClose={onClose}
          variant={variant}
          isMobile={isMobile}
          entryProperties={entryProperties.properties}
        />
      </Dialog>
    );
  }, [isMobile, openModal, setOpenModal, onClose]);

  return (
    <>
      <FormControlLabel
        labelPlacement="end"
        control={
          <Checkbox
            inputProps={{ "aria-labelledby": "partial-stay-label" }}
            checked={openModal}
            onChange={(e) => {
              setOpenModal(e.target.checked);
              if (e.target.checked) {
                trackEvent({
                  eventName: TAPPED_SMOKETEST_CTA,
                  properties: {
                    ...entryProperties.properties,
                    test_name:
                      variant === PARTIAL_STAYS
                        ? "package_partial_stay"
                        : variant === ADD_CARS
                        ? "package_add_car"
                        : variant,
                  },
                });
              }
            }}
            color="primary"
            className={clsx("partial-stay-checkbox", { checked: openModal })}
          />
        }
        label={
          <Typography id="partial-stay-label" className="label-text">
            {variant === PARTIAL_STAYS
              ? "I only need a hotel for part of my stay"
              : "Add car"}
          </Typography>
        }
        className={clsx("partial-stay-smoke-test-form", { mobile: isMobile })}
      />
      {renderPopover()}
    </>
  );
};
